import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the accounts and factoring api
 */
export class AccountService extends BaseService {

	constructor() {	
		super();
	}
	
	//[FACTORS]
	
	async getFactorSetups(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/factor-setups' + params);		
		return data;		
	}
	
	async getFactorSetup(factorSetupId) {
		var data = await this.makeGETRequest('/api/resource/factor-setups/' + factorSetupId);		
		return data;		
	}
	
	async saveFactorSetup(factorSetup, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/factor-setups/' + factorSetup.factorSetupId, factorSetup);
		} else {
			saved = await this.makePOSTRequest('/api/resource/factor-setups', factorSetup);
		}
		return saved;		
	}	
	
	async deleteFactorSetup(factorSetupId) {
		var data = await this.makeDELETERequest('/api/resource/factor-setups/' + factorSetupId);		
		return data;		
	}
	
	exportFactorSetup(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/factor-setups/export' + params);		
	};	
	
	async getAccountFactorSetup(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/factor-setups');		
		return data;		
	}
	
	async getAccountFactorAudits(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/factor-audits');		
		return data;		
	}
	
	async getAccountFactorAuditsForInvoice(companyId, invoiceNo) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/factor-audits/' + invoiceNo);		
		return data;		
	}	
	
	async getAccountFactorAuditDetails(companyId, accountFactorId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/factor-audits/' + accountFactorId + '/details' + params);
		return data;		
	}	
	
	//[ACCOUNTS]	
	async getAccounts(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/accounts' + params);		
		return data;		
	}
	
	async getAccount(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId);		
		return data;		
	}	
	
	async getAccountDetails(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/details');		
		return data;		
	}
	
	async updateBillingOptions(companyId, billingOptions) {
		var saved = await this.makePUTRequest('/api/resource/accounts/' + companyId + '/billing-options', billingOptions);
		return saved;		
	}
	
	async updateAccountOptions(companyId, accountOptions) {
		var saved = await this.makePUTRequest('/api/resource/accounts/' + companyId + '/account-options', accountOptions);
		return saved;		
	}

	async getAccountCurrentPaymethod(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/paymethods/current');		
		return data;		
	}	
	
	async updateCurrentPaymethod(companyId, paymethod) {
		var saved = await this.makePUTRequest('/api/resource/accounts/' + companyId + '/paymethods/current', paymethod);
		return saved;		
	}	
	
	async closeAccount(companyId, comment, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var saved = await this.makePUTRequest('/api/resource/accounts/' + companyId + '/close' + params, comment);
		return saved;		
	}
	
	async reopenAccount(companyId, comment) {
		var saved = await this.makePUTRequest('/api/resource/accounts/' + companyId + '/reopen', comment);
		return saved;		
	}	
	
	async clearAccount(companyId) {
		var saved = await this.makePUTRequest('/api/resource/accounts/' + companyId + '/clear');
		return saved;		
	}

	async purgeIncompleteAccount(companyId) {
		var data = await this.makeDELETERequest('/api/resource/accounts/' + companyId + '/incomplete');
		return data;
	}
	
	
	//[COMMENTS]	
	async getAccountComments(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/comments');		
		return data;		
	}

	async getAccountComment(companyId, commentId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/comments/' + commentId);		
		return data;		
	}
	
	async saveComment(companyId, comment, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/accounts/' + companyId + '/comments/' + comment.acctCommentId, comment);
		} else {
			saved = await this.makePOSTRequest('/api/resource/accounts/' + companyId + '/comments', comment);
		}
		return saved;		
	}	
	
	async deleteComment(companyId, commentId) {
		var data = await this.makeDELETERequest('/api/resource/accounts/' + companyId + '/comments/' + commentId);		
		return data;		
	}	
	
	
	//[INVOICE]
	async getAccountInvoices(companyId, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/invoices' + params);		
		return data;		
	}
	
	async getAccountInvoice(companyId, invoiceNo) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/invoices/' + invoiceNo);		
		return data;		
	}	
	
	async getAccountPreviewNextInvoice(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/invoices/preview');		
		return data;		
	}
	
	/**
	 * Use to display the invoice
	 * @param {String} companyId
	 * @param {type} options
	 * @returns string url to the view
	 */	
	viewPreviewInvoice(companyId, options) {
		options = options ? options : {
			type: 'HTML',
			download: false
		};
		
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var viewURL = '/api/resource/accounts/' + companyId + '/invoices/preview/export' + params;
		return viewURL;	
	}
	
	/**
	 * Use to display the invoice
	 * @param {String} companyId
	 * @param {String} invoiceNo
	 * @param {type} options
	 * @returns string url to the view
	 */
	viewInvoice(companyId, invoiceNo, options) {
		options = options ? options : {
			type: 'HTML',
			download: false
		};
		
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var viewURL = '/api/resource/accounts/' + companyId + '/invoices/' + invoiceNo + '/export' + params;
		return viewURL;	
	}
	
	downloadInvoicePreview(companyId, options) {
		options = options ? options : {
			download: true
		};
		
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		this.downloadFile('/api/resource/accounts/' + companyId + '/invoices/preview/export' + params, true);		
	};
	
	downloadInvoice(companyId, invoiceNo, options) {
		options = options ? options : {
			download: true
		};
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		this.downloadFile('/api/resource/accounts/' + companyId + '/invoices/' + invoiceNo + '/export' + params, true);		
	};	
		
	async emailInvoice(companyId, invoiceNo, addresses) {			
		var saved = await this.makePOSTRequestText('/api/resource/accounts/' + companyId + '/invoices/' + invoiceNo + '/email', addresses);
		return saved;		
	}	


	//[ADJUSTMENTS]
	async getAccountAdjustments(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/adjustments');		
		return data;		
	}	
	
	async saveAdjustment(companyId, adjustment, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}		
		var saved = await this.makePOSTRequest('/api/resource/accounts/' + companyId + '/adjustments' + params, adjustment);
		return saved;		
	}	
	
	async deleteAdjustment(companyId, adjustmentId, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var data = await this.makeDELETERequest('/api/resource/accounts/' + companyId + '/adjustments/' + adjustmentId + params);		
		return data;		
	}	
	
	//[orders]	
	async getOrders(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/orders');		
		return data;		
	}
	
	async saveNewOrder(companyId, orderItems, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}		
		var saved = await this.makePOSTRequest('/api/resource/accounts/' + companyId + '/orders' + params, orderItems);
		return saved;		
	}	
	
	async updateOrderItem(companyId, customerOrderNo, customerItemId, orderItem) {
		var saved = await this.makePUTRequest('/api/resource/accounts/' + companyId + '/orders/' + customerOrderNo + '/order-items/' + customerItemId, orderItem);
		return saved;		
	}
	
	async removeCancelRequestOnOrderItems(companyId, customerOrderNo, orderItemIds) {
		var saved = await this.makePUTRequest('/api/resource/accounts/' + companyId + '/orders/' + customerOrderNo + '/order-items/cancel-remove', orderItemIds);
		return saved;		
	}	
	
	async deleteOrderItems(companyId, customerOrderNo, orderItems, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		var data = await this.makeDELETERequest('/api/resource/accounts/' + companyId + '/orders/' + customerOrderNo + '/order-items' + params, orderItems);		
		return data;		
	}
	
	//[Balances]	
	async getBalances(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/balances');		
		return data;		
	}	
	
	async updateBalance(companyId, newBalance) {			
		var saved = await this.makePOSTRequest('/api/resource/accounts/' + companyId + '/balances', newBalance);
		return saved;		
	}
	
	
	//[PAYMENTS]	
	async getPayments(companyId, options) {
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}		
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/payments' + params);		
		return data;		
	}
	
	async getPayment(companyId, paymentIdOrCreditId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/payments/' + paymentIdOrCreditId);		
		return data;		
	}	
	
	async postPaymentCredit(companyId, paymentOrCredit) {			
		var saved = await this.makePOSTRequest('/api/resource/accounts/' + companyId + '/payments', paymentOrCredit);
		return saved;		
	}	
	
	//[CONTRACTS]
	async getApplicationContracts(companyId) {
		var data = await this.makeGETRequest('/api/resource/accounts/' + companyId + '/contracts');		
		return data;		
	}
	
	downloadContract(companyId, contractId) {			
		this.downloadFile('/api/resource/accounts/' + companyId + '/contracts/' + contractId);		
	};		
	
	async deleteContract(companyId, contractId) {		
		var data = await this.makeDELETERequest('/api/resource/accounts/' + companyId + '/contracts/' + contractId);		
		return data;		
	}	
	
}

